export default __webpack_public_path__ + "static/media/ChevronDownFilled.feddb38b.svg";